import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'

const config: SkyNetTableConfig = {
    tabs: [{
        name: 'Upcoming Container Selection',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                filterField: 'orderNumber',
                filterType: FilterType.Array,
                width: '100px',
                labelKey: 'ORDER',
            },
            {
                name: 'originAirportIataCode',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
                width: '135px',
                labelKey: 'ORIGIN_AIRPORT',
            },
            {
                name: 'destinationAirportIataCode',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
                width: '170px',
                labelKey: 'DESTINATION_AIRPORT',
            },
            {
                name: 'customerLocationName',
                filterField: 'customerLocationName',
                filterType: FilterType.Array,
                labelKey: 'CUSTOMER',
            },
            {
                name: 'pricingAccountCompanyName',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
                labelKey: 'PRICING_ACCOUNT',
            },
            {
                name: 'originLocationLocationName',
                filterField: 'originLocationLocationName',
                filterType: FilterType.Array,
                labelKey: 'ORIGIN_LOCATION',
            },
            {
                name: 'handoverPointLocationName',
                filterField: 'handoverPointLocationName',
                filterType: FilterType.Array,
                labelKey: 'HANDOVER_POINT',
            },
            {
                name: 'plannedPickup',
                filterField: 'plannedPickup',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
                labelKey: 'PLANNED_PICK_UP_ON',
            },
            {
                name: 'requiredContainers',
                componentName: 'List',
                sorting: false,
                labelKey: 'REQUIRED_CONTAINERS',
            },
            {
                name: 'containerSelectionUntilUtc',
                componentName: 'ContainerSelectionUntil',
                labelKey: 'REMAINING_OVERDUE',
            },
        ],
    }],
}

export default config
